import React from "react";
import "../css/dashboard.css";
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { useEffect } from "react";
import { roles } from "../firebase.collection";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import ClientNotesMainMobile from "../component/ClientsCategory/ClientNotesMainMobile";
import ClientNotesMainNotTherapistMobile from "../component/ClientsCategory/ClientNotesMainNotTherapistMobile";
import ClientNotesMainMedicalStaffMobile from "../component/ClientsCategory/ClientNotesMainMedicalStaffMobile";
import ClientNotesMainHospitalityMobile from "../component/ClientsCategory/ClientNotesMainHospitalityMobile";

export default function NoteContentMobile(props) {
  //VARIABLES
  const { currentUser } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";

  //STATES
  const [userRole, setUserRole] = useState("");

  //FUNCTIONS

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  // useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics(
  //       "Notes",
  //       "pageLoadMobile",
  //       currentUser.email,
  //       "read",
  //       "bodhi"
  //     );
  //   }
  // }, [currentUser.email]);

  return (
    <div className="right-container-mobile">
      <TopTitleBannerMobile title={"Notes"} />

      <div className="tab-form-container-mobile-v2 ">
        {(() => {
          if (userRole === "Therapist" || userRole === "Super Admin") {
            return <ClientNotesMainMobile {...props} />;
          } else if (userRole === "Medical Staff") {
            return <ClientNotesMainMedicalStaffMobile {...props} />;
          } else if (userRole === "Hospitality Staff") {
            return <ClientNotesMainHospitalityMobile {...props} />;
          } else {
            return <ClientNotesMainNotTherapistMobile {...props} />;
          }
        })()}
      </div>
    </div>
  );
}
